var React = require('react');

function Sensor (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M384,32H64A64,64,0,0,0,0,96V416a64,64,0,0,0,64,64H384a64,64,0,0,0,64-64V96A64,64,0,0,0,384,32ZM96,272a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Zm64,0a16,16,0,0,1-32,0V112a16,16,0,0,1,32,0Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M80,96a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V112A16,16,0,0,0,80,96Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V112A16,16,0,0,0,144,96Zm64,0a16,16,0,0,0-16,16V272a16,16,0,0,0,32,0V112A16,16,0,0,0,208,96Z","className":"fa-primary","key":2})]);
}

Sensor.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Sensor;

Sensor.default = Sensor;
